class CartNote extends HTMLElement {
  constructor() {
    super();
    this.textarea = this.querySelector("textarea");
    this.debouncedOnSubmit = debounce(() => this.onSubmit(), 750);
    this.noteField = this.querySelector(".cart__note-field");
    this.details = this.querySelector("details");

    this.textarea.addEventListener("input", this.debouncedOnSubmit.bind(this));

    // Reset animation each time details opens
    if (this.details) {
      this.details.addEventListener("toggle", this.onToggle.bind(this));
    }
  }

  onToggle() {
    if (this.details && this.details.hasAttribute("open") && this.noteField) {
      // Remove animation class to reset
      this.noteField.classList.remove("animate-slide-up");
      // Force reflow to ensure the class removal is processed
      void this.noteField.offsetWidth;
      // Re-add animation class to trigger animation
      this.noteField.classList.add("animate-slide-up");
    }
  }

  async onSubmit() {
    try {
      const response = await fetch(`${routes.cart_update_url}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({ note: this.textarea.value }),
      });

      // Check if response is JSON before parsing
      const contentType = response.headers.get("content-type");
      if (contentType && contentType.includes("application/json")) {
        const data = await response.json();
        // Add inside the .then() callback
        const successMsg = this.querySelector(".cart-note__success");
        successMsg.classList.add("active");
        setTimeout(() => successMsg.classList.remove("active"), 2000);
      } else {
        console.log("Cart note updated (non-JSON response)");
      }
    } catch (error) {
      console.error("Error updating cart note:", error);
    }
  }
}

customElements.define("cart-note", CartNote);
